import { render, staticRenderFns } from "./AppbarAccount.vue?vue&type=template&id=371f4650&"
import script from "./AppbarAccount.vue?vue&type=script&lang=js&"
export * from "./AppbarAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports